/* eslint-disable */
export default (typeof global !== 'undefined'
  ? global
  : typeof window !== 'undefined' ? window : {});



// WEBPACK FOOTER //
// ../src/utils/global.js